export const GET_ALL_BEHAVIORS = "GET_ALL_BEHAVIORS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_BEHAVIORS = "START_LOADING_BEHAVIORS";
export const STOP_LOADING_BEHAVIORS = "STOP_LOADING_BEHAVIORS";
export const ERROR_LOADING_BEHAVIORS = "ERROR_LOADING_BEHAVIORS";